module.exports = __webpack_public_path__ + "img/rusia2018.79125093.jpg";